import StoreModuleService from '../StoreModuleService';
import { initialState } from './state';
import Vue from 'vue';

export const SET_LOADING = 'SET_LOADING';
export const SET_INBOXES = 'SET_INBOXES';
export const SET_INBOX = 'SET_INBOX';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[SET_LOADING](state, value) {
		Vue.set(state, 'loading', value);
	},
	[SET_INBOXES](state, inboxes) {
		Vue.set(state, 'inboxes', { ...state.inboxes, ...inboxes });
	},
	[SET_INBOX](state, inbox) {
		if (!inbox.id) {
			throw new Error(`unable to get id from: ${inbox}`);
		}
		Vue.set(state.inboxes, inbox.id, inbox);
	},
};

export default mutations;
